module.exports = __webpack_public_path__ + "img/logo.8dc10921.png";